export default __webpack_public_path__ + "static/media/ntu-logo.2c398196.png";